import spinner from "../../assets/gif/loader.gif";
export default function LoadingSpinner() {
  return <img src={spinner} width="21" alt={"Loading"} className={"loader"} />;
}
